import React from 'react';
import { TrendingUp, CreditCard, Wallet, DollarSign, Wrench, Building } from 'lucide-react';
import { useTranslations } from '../hooks/useTranslations';
export function FundingSolutions() {
  const {
    t
  } = useTranslations();
  const solutions = [{
    icon: <TrendingUp className="w-5 h-5 text-white" data-id="element-182" />,
    iconBg: 'bg-blue-500',
    title: t('solutions.card1.title'),
    desc: t('solutions.card1.desc')
  }, {
    icon: <CreditCard className="w-5 h-5 text-white" data-id="element-183" />,
    iconBg: 'bg-red-500',
    title: t('solutions.card2.title'),
    desc: t('solutions.card2.desc')
  }, {
    icon: <Wallet className="w-5 h-5 text-white" data-id="element-184" />,
    iconBg: 'bg-teal-500',
    title: t('solutions.card3.title'),
    desc: t('solutions.card3.desc')
  }, {
    icon: <DollarSign className="w-5 h-5 text-white" data-id="element-185" />,
    iconBg: 'bg-orange-500',
    title: t('solutions.card4.title'),
    desc: t('solutions.card4.desc')
  }, {
    icon: <Wrench className="w-5 h-5 text-white" data-id="element-186" />,
    iconBg: 'bg-emerald-500',
    title: t('solutions.card5.title'),
    desc: t('solutions.card5.desc')
  }, {
    icon: <Building className="w-5 h-5 text-white" data-id="element-187" />,
    iconBg: 'bg-purple-500',
    title: t('solutions.card7.title'),
    desc: t('solutions.card7.desc')
  }];
  return <section id="funding" className="py-12 bg-[#f0faf4]" data-id="element-188">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-189">
        <div className="text-center mb-10" data-id="element-190">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-191">
            {t('solutions.title')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-192">
          {solutions.map((solution, index) => <div key={index} className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow border border-gray-100 flex flex-col items-center text-center h-full" data-id="element-193">
              <div className={`w-12 h-12 rounded-lg ${solution.iconBg} flex items-center justify-center mb-4`} data-id="element-194">
                {solution.icon}
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2 uppercase" data-id="element-195">
                {solution.title}
              </h3>
              <p className="text-xs text-gray-500 leading-relaxed flex-grow" data-id="element-196">
                {solution.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}